import React, { useState } from "react";


function FlightFarePrediction() {
  const [resp, setResp] = useState(null);
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const url = "https://aniketsonii.pythonanywhere.com/predict"
      const method = "POST";
      const form = document.querySelector('#predict');
      const formData = new FormData(form);
      const result = await getResponse(url, formData, method, null);
      setResp(result);
    } catch (error) {
      console.error("Error:", error);

    } finally {

    }
  };


  return (
    <>
      <div class="flex flex-col min-h-screen bg-[url('https://images.pexels.com/photos/11150272/pexels-photo-11150272.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2')] h-screen bg-cover">
        <div class="flex justify-center items-center px-4 py-32 rounded-lg shadow-md">
          <form id="predict" onSubmit={handleSubmit}>
            <div class="flex flex-col w-full space-y-4">
              <div class="flex flex-row justify-between items-center">
                <h1 class="text-2xl font-bold">Flight Booking</h1>
              </div>
              <div class="flex flex-row space-x-4">
                <div class="flex flex-col">
                  <label for="source" class="font-semibold text-sm">
                    Source
                  </label>
                  <select
                    name="Source"
                    id="source"
                    required="required"
                    className="px-4 py-2 border rounded-md focus:outline-violet-700 focus:ring-violet-700"
                  >
                    <option value="Delhi">Delhi</option>
                    <option value="Kolkata">Kolkata</option>
                    <option value="Mumbai">Mumbai</option>
                    <option value="Chennai">Chennai</option>
                  </select>
                </div>
                <div class="flex flex-col">
                  <label for="destination" class="font-semibold text-sm">
                    Destination
                  </label>
                  <select
                    name="Destination"
                    id="destination"
                    required="required"
                    className="px-4 py-2 border rounded-md focus:outline-violet-700 focus:ring-violet-700"
                  >
                    <option value="Cochin">Cochin</option>
                    <option value="Delhi">Delhi</option>
                    <option value="New Delhi">New Delhi</option>
                    <option value="Hyderabad">Hyderabad</option>
                    <option value="Kolkata">Kolkata</option>
                  </select>
                </div>
                <div class="flex flex-col">
                  <label for="stoppage" class="font-semibold text-sm">
                    Stoppage(s)
                  </label>
                  <select
                    name="stops"
                    id="Stoppage"
                    required="required"
                    className="px-4 py-2 border rounded-md focus:outline-violet-700 focus:ring-violet-700"
                  >
                    <option value="0">Non-Stop</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                  </select>
                </div>
                <div class="flex flex-col">
                  <label for="airline" class="font-semibold text-sm">
                    Airline
                  </label>
                  <select
                    name="airline"
                    id="airline"
                    required="required"
                    className="px-4 py-2 border rounded-md focus:outline-violet-700 focus:ring-violet-700"
                  >
                    <option value="Jet Airways">Jet Airways</option>
                    <option value="IndiGo">IndiGo</option>
                    <option value="Air India">Air India</option>
                    <option value="Multiple carriers">Multiple carriers</option>
                    <option value="SpiceJet">SpiceJet</option>
                    <option value="Vistara">Vistara</option>
                    <option value="Air Asia">Air Asia</option>
                    <option value="GoAir">GoAir</option>
                    <option value="Multiple carriers Premium economy">
                      Multiple carriers Premium economy
                    </option>
                    <option value="Jet Airways Business">
                      Jet Airways Business
                    </option>
                    <option value="Vistara Premium economy">
                      Vistara Premium economy
                    </option>
                    <option value="Trujet">Trujet</option>
                  </select>
                </div>
              </div>
              <div class="flex flex-row space-x-4">
                <div class="flex flex-col">
                  <label for="departureDate" class="font-semibold text-sm">
                    Departure Date
                  </label>
                  <input
                    name="Dep_Time"
                    required
                    type="date"
                    id="departureDate"
                    class="px-4 py-2 border rounded-md focus:outline-violet-700 focus:ring-violet-700"
                  />
                </div>
                <div class="flex flex-col">
                  <label for="arrivalDate" class="font-semibold text-sm">
                    Arrival Date
                  </label>
                  <input
                    name="Arrival_Time"
                    required
                    type="date"
                    id="arrivalDate"
                    class="px-4 py-2 border rounded-md focus:outline-violet-700 focus:ring-violet-700"
                  />
                </div>
              </div>
              <button
                type="submit"
                value="Search Flights"
                class="px-2 py-2 bg-violet-700 text-white font-bold rounded-lg shadow-md hover:bg-violet-950"
              >
                Submit
              </button>
            </div>
          </form>

          {/* <output form="predict"></output> */}
        </div>
        {resp ? (
          <div class="text-center rounded-lg min-h-max shadow-md bg-white p-4">
            <span class="text-3xl font-bold violet-950">₹{resp.price}/-</span>
            <p class="text-gray-500 text-lg mt-2"> Predicted Flight Price</p>
            <p class="text-gray-500 text-xs mt-2"> *The predicted price is based on historical data and may not be entirely accurate.</p>
          </div>
        ) : (
          ""
        )}
        
      </div>
    </>
  );
}


async function getResponse(url, dataurl, method, contentType) {
  try {
    const response = await fetch(url, {
      method: method,
      headers: {
        ...(contentType !== null ? { "Content-Type": contentType } : {}),
        "Access-Control-Allow-Origin": "https://aniketsonii.pythonanywhere.com/*",
        "Access-Control-Allow-Headers": "Content-Type",
        "Access-Control-Allow-Methods": "*",
      },
      body: dataurl,
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json(); // Extracting data as a JSON Object from the response

    // Depending on your use case, you might want to return or do something with the data
    return data;
  } catch (error) {
    throw error;
    // Handle the error as needed
  }

}


export default FlightFarePrediction;
